import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '../utils'

const buttonVariants = cva(
  'inline-flex select-none items-center justify-center gap-[calc(var(--sb-spacing-sm)/2)] rounded-[var(--sb-radius-md)] px-[var(--sb-spacing-md)] py-[calc(var(--sb-spacing-sm)*0.75)] text-sm font-semibold tracking-[-0.01em] transition-colors duration-200 ease-sb-motion focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[color:var(--sb-color-primary)] focus-visible:ring-offset-[color:var(--sb-color-surface)] disabled:pointer-events-none disabled:opacity-60 shadow-[0_2px_0_rgba(15,23,42,0.05)]',
  {
    variants: {
      variant: {
        primary:
          'bg-[color:var(--sb-color-primary)] text-[color:var(--sb-color-text-inverse)] hover:bg-[color:var(--sb-color-primary-strong)] data-[state=open]:bg-[color:var(--sb-color-primary-strong)] shadow-[0_14px_30px_rgba(99,91,255,0.22)]',
        secondary:
          'bg-[color:var(--sb-color-primary-surface)] text-[color:var(--sb-color-primary)] hover:bg-[color:var(--sb-color-primary-surface)]/80 border border-[color:var(--sb-color-border-subtle)]',
        outline:
          'border border-[color:var(--sb-color-border-strong)] bg-[color:var(--sb-color-surface)] text-[color:var(--sb-color-text-strong)] hover:border-[color:var(--sb-color-primary)] hover:text-[color:var(--sb-color-primary)]',
        subtle:
          'bg-[color:var(--sb-color-surface-muted)] text-[color:var(--sb-color-text-strong)] hover:bg-[color:var(--sb-color-surface-muted)]/80'
      },
      size: {
        md: 'h-11 min-w-[3rem]',
        sm: 'h-9 text-xs px-[calc(var(--sb-spacing-sm)*1.25)]'
      }
    },
    defaultVariants: {
      variant: 'primary',
      size: 'md'
    }
  }
)

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, type = 'button', ...props }, ref) => (
    <button
      ref={ref}
      type={type}
      data-ui-button
      className={cn(buttonVariants({ variant, size }), className)}
      {...props}
    />
  )
)
Button.displayName = 'Button'
